export default {
    /**
     * Sends the contact request.
     *
     * @param  Vue instance
     */
    postContact(vm) {
        vm.sendingForm = true;

        axios
            .post("/contact", vm.contact)
            .then(response => {
                //sucesso
                if (response.data.status) {
                    swal("OK", "Contato enviado com sucesso!", "success").then(
                        value => {
                            window.location.reload(false);
                        }
                    );
                } else {
                    swal(
                        "Ooops...",
                        "Não foi possível enviar o contato.",
                        "error"
                    );
                }

                vm.sendingForm = false;
            })
            .catch(function(error) {
                if (error.response.status === 422) {
                    let errosValidacao = error.response.data.errors;

                    let campos = Object.keys(errosValidacao);

                    let arrayErros = [];

                    campos.forEach(campo => {
                        arrayErros.push(errosValidacao[campo][0]);
                    });

                    swal("Ooops...", arrayErros.join("\n"), "error");

                    vm.sendingForm = false;
                }
            });
    }
};
